export default __webpack_public_path__ + "static/media/Pistol_4.2861857d.png";